
const CrudCodeValues = require("./CrudCodeValues");
module.exports = {
    ALC: "ALC",
    CALC: "CALC",
    CONTR: "CONTR",
    DSG: "DSG",
    EMP: "EMP",
    EST: "EST",
    MEAS: "MEAS",
    PLAN: "PLAN",
    REQ: "REQ",
    SET: "SET",
    SPEC: "SPEC"
}
